import React from "react"
import styled from "styled-components"
import { LogoHeading, tagLine } from "../Styles/TextStyles"
import { themes } from "../Styles/ColorStyles"

function ProductSection() {
  return (
    <Wrapper>
      <ContentWrapper>
        <TextWrapper>
          <Title>ProApps</Title>
          <Description>Learn from your iOS Device!</Description>
        </TextWrapper>
        <Preview>
          <Image src="../PM/Logo-1.png" />
        </Preview>
      </ContentWrapper>
    </Wrapper>
  )
}

export default ProductSection

const Wrapper = styled.div`
  background: linear-gradient(
    150.51deg,
    #9076e7 8.86%,
    #ef325f 23.93%,
    #59248a 60.22%
  );
  transform: matrix(1, 0, 0, 1, 0, 0);
  overflow: hidden;
`
const Preview = styled.div``

const Image = styled.img`
  max-width: 200;
  max-height: 200;
`

const ContentWrapper = styled.div`
  max-width: 1234px;
  margin: 0 auto;
  padding: 200px 30px;
  display: grid;
  grid-template-columns: 360px auto;
`

const TextWrapper = styled.div`
  max-width: 360px;
  display: grid;
  gap: 30px;
`
const Title = styled(LogoHeading)`
  color: ${themes.dark.text1};
`

const Description = styled(tagLine)`
  color: ${themes.dark.text1};
`
